module.exports = __webpack_public_path__ + "media/images/flags/fk-0d29b851ede91eeb197d2f6af55d9a29.svg";